<template>
  <b-card>
    <tipo-atividade-list
      :carregar="carregar"
      :novo="novo"
      :editar="editar"
      :remover="remover"
      :colunas="colunasListagem"
      :info="info"
      :filtros="filtros"
    />
  </b-card>
</template>

<script>
import api from '@/app-modulo/comercial/tipo-atividade/shared/services/api'

export default {
  name: 'TipoAtividadeVisualizacao',
  components: {
    TipoAtividadeList: () => import('@/shared/components/visualizacao-base/VisualizacaoBase.vue'),
  },
  data() {
    return {
      colunasListagem: [
        {
          label: 'Nome', field: 'nome', editable: true,
        },
      ],
      filtros: [{ colunas: ['Nome'], valor: null }],
      info: [
        { label: 'Data de cadastro: ', campo: 'dataCadastro' },
        { label: 'Cadastrado por: ', campo: 'usuCadastro' },
        { label: 'Data de alteração: ', campo: 'dataAlteracao' },
        { label: 'Alterado por: ', campo: 'usuAlteracao' },
      ],
    }
  },
  methods: {
    carregar(page, pageSize, filtros) {
      return api.getTiposAtividade(page, pageSize, filtros)
    },
    novo() {
      this.$router.push({ name: 'novo-tipo-atividade' })
    },
    editar(value) {
      this.$router.push({ name: 'editar-tipo-atividade', params: { id: value.id } })
    },
    remover(itens) {
      const itensInner = itens
      if (itensInner && itensInner.length === 1) {
        return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-plusplus
          for (let i = 0; i < itensInner.length; i++) {
            const item = itensInner[i]
            api.existeAtividadeVinculoChecklist(item.id)
              .then(payload => {
                if (!payload.data) {
                  api.deleteTipoAtividade(item.id)
                    .then(() => {
                      resolve()
                    })
                    .catch(err => {
                      reject(err)
                    })
                } else {
                  this.$swal({
                    text: 'Não é permitido realizar essa exclusão, pois este registro está associado em campos obrigatórios de outros cadastros.',
                    icon: 'warning',
                    confirmButtonText: 'Ok',
                    customClass: {
                      confirmButton: 'btn btn-primary',
                    },
                  })
                  reject()
                }
              })
          }
        })
      }

      const idList = itens.map(map => map.id)
      return api.deleteAll({ identificadores: idList })
    },
  },
}
</script>
